const { subDays, format, addDays } = require("date-fns");

function getPast30Dates({ currentDate }) {
  const pastDates = [];
  const current = new Date(currentDate);

  for (let i = 0; i < 30; i++) {
    const date = subDays(current, i);
    pastDates.unshift({
      date: format(date, "yyyy-MM-dd"),
      day: format(date, "EEEE"),
      month: format(date, "MMM").toUpperCase(),
    });
  }

  return pastDates;
}
exports.getPast30Dates = getPast30Dates;

function getCurrentWeek({ currentDate }) {
  const current = new Date(currentDate);
  const dayOfWeek = current.getDay();

  const startOfWeek = subDays(current, dayOfWeek);

  const weekDays = [];

  for (let i = 0; i < 7; i++) {
    const date = addDays(startOfWeek, i);
    if (date <= new Date()) {
      weekDays.push({
        date: format(date, "yyyy-MM-dd"),
        day: format(date, "EEEE"),
        month: format(date, "MMM").toUpperCase(),
      });
    }
  }

  return weekDays;
}

exports.getCurrentWeek = getCurrentWeek;
